import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getHonourHome = async (params: object) => {
  return await GET({ url: Api.getHonourHome, params, showError: false })
}

export const askForLeave = async (params: object) => {
  return await GET({ url: Api.askForLeave, params, showError: false })
}

export const honourJoin = async (params: object) => {
  return await GET({ url: Api.honourJoin, params, showError: false })
}

export const honourQuit = async (params: object) => {
  return await GET({ url: Api.honourQuit, params, showError: false })
}

export const getPropTips = async (params: object) => {
  return await GET({ url: Api.getPropTips, params, showError: false })
}
